import React, { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";

import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../Features/Cart/cartSlice";

import product1 from "../../../Assets/ProductDetail/productdetail-1.jpg";
import product2 from "../../../Assets/ProductDetail/productdetail-2.jpg";
import product3 from "../../../Assets/ProductDetail/productdetail-3.jpg";
import product4 from "../../../Assets/ProductDetail/productdetail-4.jpg";

import { GoChevronLeft } from "react-icons/go";
import { GoChevronRight } from "react-icons/go";
import { FaStar } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import { PiShareNetworkLight } from "react-icons/pi";

import { Link } from "react-router-dom";

import toast from "react-hot-toast";

import axios from "axios";
import * as backendModule from "../../../modules/backendModule";
import Spinner from "../../Spinner";

import "./Product.css";

const Product = (props) => {
  // Product images Gallery
  const productImg = [product1, product2, product3, product4];
  const [currentImg, setCurrentImg] = useState(0);

  const prevImg = () => {
    setCurrentImg(currentImg === 0 ? productImg.length - 1 : currentImg - 1);
  };

  const nextImg = () => {
    setCurrentImg(currentImg === productImg.length - 1 ? 0 : currentImg + 1);
  };

  // Product Quantity

  const [quantity, setQuantity] = useState(1);

  const increment = () => {
    setQuantity(quantity + 1);
  };

  const decrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleInputChange = (event) => {
    const value = parseInt(event.target.value);
    if (!isNaN(value) && value > 0) {
      setQuantity(value);
    }
  };

  // Product WishList

  const [clicked, setClicked] = useState(false);

  const handleWishClick = () => {
    setClicked(!clicked);
  };

  // Product Sizes

  const sizes = ["XS", "S", "M", "L", "XL"];
  const sizesFullName = [
    "Extra Small",
    "Small",
    "Medium",
    "Large",
    "Extra Large",
  ];
  const [selectSize, setSelectSize] = useState("S");

  // Product Colors

  const [highlightedColor, setHighlightedColor] = useState("#C8393D");
  const colors = ["#222222", "#C8393D", "#E4E4E4"];
  const colorsName = ["Black", "Red", "Grey"];

  // Product Detail to Redux

  const dispatch = useDispatch();

  const cartItems = useSelector((state) => state.cart.items);

  const handleAddToCart = () => {
    const productDetails = {
      ID: props.productID,
      Name: data?.Name,
      Price: data?.Price,
      ImagePath: data?.ImagePath,
      productReviews: "100+ ocjena",
    };

    const productInCart = cartItems.find(
      (item) => item.productID === productDetails.productID
    );

    if (productInCart && productInCart.quantity >= 20) {
      toast.error("Product limit reached", {
        duration: 2000,
        style: {
          backgroundColor: "#ff4b4b",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#ff4b4b",
        },
      });
    } else {
      dispatch(addToCart(productDetails));
      toast.success(`Added to cart!`, {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    }
  };

  const [data, setData] = React.useState([]);
  const [error, setError] = React.useState(null);
  const [spinner, setSpinner] = React.useState(true);

  const getData = () => {
    axios({
      method: "POST",
      url: `${backendModule.backendURL}/products/getProductByID`,
      data: {
        ID: props.productID
      },
      ...backendModule.axiosConfig,
    }).then(res => {
      if (res.data.status === "ok") {
        setData(res.data?.data);
        setCurrentImg(res.data?.data.ImagePath);
        setError(null);
      } else {
        setError('Došlo je do serverske greške');
      }
    }).catch(() => {
      setError('Došlo je do serverske greške');
    }).finally(() => {
      setSpinner(false);
    });
  }

  React.useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className="productSection">
        {!spinner && !error ? <div className="productShowCase">
          <div className="productGallery">
            <div className="productThumb">
              <img src={`${backendModule.backendURL}/${data?.ImagePath}`} onClick={() => setCurrentImg(data?.ImagePath)} alt="" />
              <img src={`${backendModule.backendURL}/${data?.ImagePath2}`} onClick={() => setCurrentImg(data?.ImagePath2)} alt="" />
            </div>
            <div className="productFullImg">
              <img src={`${backendModule.backendURL}/${currentImg}`} alt="" />
            </div>
          </div>
          <div className="productDetails">
            <div className="productBreadcrumb">
              <div className="breadcrumbLink">
                <Link to="/">Home</Link>&nbsp;/&nbsp;
                <Link to="/shop">The Shop</Link>
              </div>
            </div>
            <div className="productName">
              <h1>{data?.Name}</h1>
            </div>
            <div className="productRating">
              <FaStar color="#FEC78A" size={10} />
              <FaStar color="#FEC78A" size={10} />
              <FaStar color="#FEC78A" size={10} />
              <FaStar color="#FEC78A" size={10} />
              <FaStar color="#FEC78A" size={10} />
              <p>100+ ocjena</p>
            </div>
            <div className="productPrice">
              <h3>{Number(data?.Price).toFixed(2)} KM</h3>
            </div>
            <div className="productDescription">
              <p>
                Model: {data?.Model}
              </p>
              <div className="taglines">
                <img src="imgs/globe.png" />
                <p>Ovlašteni trgovac</p>
              </div>
              <div className="taglines">
                <img src="imgs/cashback.png" />
                <p>Mogućnost zamjene u roku od 15 dana</p>
              </div>
              <div className="taglines">
                <img src="imgs/fast-delivery.png" />
                <p>Brza dostava u roku 2-3 dana u sve gradove BiH</p>
              </div>
              <img src="imgs/kartice.avif" />
            </div>
            <div className="productCartQuantity">
              <div className="productQuantity">
                <button onClick={decrement}>-</button>
                <input
                  type="text"
                  value={quantity}
                  onChange={handleInputChange}
                />
                <button onClick={increment}>+</button>
              </div>
              <div className="productCartBtn">
                <button onClick={handleAddToCart}>DODAJ U KORPU</button>
              </div>
            </div>
            <div className="productTags">
              <p>
                <span>NA STANJU: </span>{data?.Available ? 'DA' : 'NE'}
              </p>
              <p>
                <span>KATEGORIJA: </span> {data?.Category}
              </p>
              <p>
                <span>BREND: </span> {data?.Brand}
              </p>
            </div>
          </div>
        </div> : null}
        {error && <p style={{color: 'red'}}>{error}</p>}
        {spinner && <Spinner color="black" style={{width: "64px", height: "50px", marginLeft: "auto", marginRight: "auto", display: "block"}} />}
      </div>
    </>
  );
};

export default Product;
